app.controller('BrowseProductIndividualDoorController', ['$rootScope', '$scope', '$bootstrapModal', function ($rootScope, $scope, $bootstrapModal) {

    const siteHelper = $rootScope.site_helper;

    const navigationIDs = $scope.navigation_ids;

    const productModel = $rootScope.factory.product_door.getModel(navigationIDs);
    $scope.product = null;

    $scope.square_edge_available = navigationIDs.parent_category_id === "door" && navigationIDs.request_range_id === "bella";


    let documentProductTag = "door_door" ;

    $scope.product_document = null;
    $rootScope.service.cache_local_server.productDocumentsByTags([navigationIDs.site_range_id, documentProductTag], function (documents) {
        $scope.product_document = documents.length > 0 ? documents[0] : null;
        if (!$scope.product_document && documentProductTag !== "door_door") {
            documents = $rootScope.service.cache_local_server.productDocumentsByTags([navigationIDs.site_range_id, "door_door"]);
            $scope.product_document = documents.length > 0 ? documents[0] : null;
        }
    })

    function applyProduct() {
        if (productModel.is_single_item_model) {
            $scope.product = productModel.product;
        } else {
            $scope.product = productModel.choices[navigationIDs.colour_id];
        }
    }

    applyProduct();
    productModel.apiRequest(applyProduct);

    $scope.alt_product_hrefs = {};
    $scope.alt_product_names = {
        door: "handleless doors",
        inset: "Inset doors",
        door_sloping: "sloping doors"
    };

    $scope.altProductOrder = function () {
        const filteredOrder = [];
        const order = ['door', 'inset', 'door_sloping'];
        for (let i = 0; i < order.length; i++) {
            const internalID = order[i];
            if ($scope.alt_product_hrefs[internalID]) {
                filteredOrder.push(internalID);
            }
        }
        return filteredOrder;
    }

    $scope.altProductPrefix = function (altID) {
        const order = $scope.altProductOrder();
        const isFirst = order[0] === altID;
        const isLast = order[order.length - 1] === altID;
        return isFirst ? "" : (isLast ? " or " : ", ");
    }

    function addDoorSlopingHref() {


        const componentObject = $rootScope.service.cache_local_server.getComponentObject(productModel.base_component_id, null, "door_sloping");
        if (!$rootScope.service.cache_local_server.isComponentObjectAvailable(componentObject, navigationIDs.site_range_id, navigationIDs.colour_id, navigationIDs.style_id)) {
            return;
        }

        const routeIDs = siteHelper.simpleCloneObject(navigationIDs);
        if (navigationIDs.browse_id === "component") {
            routeIDs.component_id = "door_sloping";
        }
        routeIDs.tile_id = "door_sloping";
        delete routeIDs.parent_category_id;


        $scope.alt_product_hrefs.door_sloping = $rootScope.navigation_manager.createNavigationModel(null, routeIDs).href;

    }


    addDoorSlopingHref();


    function showPopUpAdvert(popUpAdvert) {

        $bootstrapModal.open({
            templateUrl: 'CommonModalSimple.html',
            controller: 'CommonModalSimpleController',
            resolve: {
                items: popUpAdvert
            }
        })
    }

    $scope.isElementDisabled = function (elementID) {
        return false;
    }

    $scope.productInfo = function () {
        if (productModel.parent_category_id === "door") {
            if (navigationIDs.site_range_id === "bella") {
                return "18mm MDF";
            } else if (navigationIDs.site_range_id === "valore") {
                return "18mm MDF with matching back";
            }
        }
        return null;
    }

    $scope.addToCartHandler = function (validateFormCallback, product) {

        const adverts = $rootScope.service.advert.collectAdverts(product);

        const complexOption = $rootScope.service.option_product.currentComplexOption(product);

        const orderLine = {

            type: product.api_code,

            quantity: product.quantity,
            cost: product.displayPrice(),

            range: product.getSubmitRangeID(),
            site_range: navigationIDs.site_range_id,
            colour: navigationIDs.colour_id,
            style: navigationIDs.style_id,

            height: product.height,
            width: product.width,

            rotate_grain: product.rotate_grain,
            jpull_position: product.jpull_position,
            left_side_square: product.left_side_square,
            right_side_square: product.right_side_square,

            option_id: complexOption.id,

            handle_colour: product.option_term_ids.handle_colour,

            integra_position: product.option_term_ids.handle_position_integra,
            knebworth_position: product.option_term_ids.handle_position_knebworth,
            handle_position: product.option_term_ids.handle_position_knebworth,

            midrail: product.option_term_values.midrail ? product.option_term_values.midrail.midrail_height : null,
            handle_offset: product.option_term_values.handle_position ? product.option_term_values.handle_position.handle_offset : null,
            inset_offset: product.option_term_values.handle_position_inset ? product.option_term_values.handle_position_inset.inset_offset : null,

            option: product.option_term_ids.selected_door_option,

            hinge_holes: $rootScope.service.product.collectHingeHoles(product),

            product_model_id: product.model_id,
            parent_category_ids: product.parent_category_ids,
            adverts: adverts,

            group_name: product.group_name
        };

        const orderBuild = {
            range: orderLine.range,
            colour: orderLine.colour,
            style: orderLine.style,
            lines: [orderLine]
        };


        $rootScope.service.product.addToCart(orderBuild, function (success, messages) {
            if (success) {

                $rootScope.service.product.resetProduct(product);

                product.height = '';
                product.width = '';
                product.left_side_square = false;
                product.right_side_square = false;


                product.rotate_grain = false;

                const postPopUps = $rootScope.service.advert.onAddedToCartAdverts(adverts)
                const postPopUp = postPopUps.length > 0 ? postPopUps[0] : null;
                if (postPopUp) {
                    showPopUpAdvert(postPopUp);
                }

            }
            if (validateFormCallback) {
                validateFormCallback(success, messages);
            }
        });
    };


}]);